// Initialize the generic .slider Swiper
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, A11y } from 'swiper/modules';
import { a11y } from './config/a11y';

export function initSlider() {
    const el = document.querySelector('.slider');
    if (!el) return null; // No instance if element is missing

    const instance = new Swiper(el, {
        modules: [Navigation, Pagination, Autoplay, A11y],
        loop: true,
        a11y,
        keyboard: {
            enabled: false,
            onlyInViewport: true
        },
        pagination: {
            el: el.querySelector('.swiper-pagination') || '.swiper-pagination',
            type: 'progressbar',
            clickable: true
        },
        navigation: {
            nextEl: el.querySelector('.swiper-button-next') || '.swiper-button-next',
            prevEl: el.querySelector('.swiper-button-prev') || '.swiper-button-prev'
        }
    });

    // Enable keyboard navigation only when swiper is focused or hovered
    const enableKeyboard = () => instance.keyboard.enable();
    const disableKeyboard = () => instance.keyboard.disable();

    el.addEventListener('mouseenter', enableKeyboard);
    el.addEventListener('mouseleave', disableKeyboard);
    el.addEventListener('focusin', enableKeyboard);
    el.addEventListener('focusout', disableKeyboard);

    return instance;
}
